module.exports = __webpack_public_path__ + "static/case_05-5d03ae50de742c31132257e4d91df2e6.jpg";